<button
  id="{{aid}}"
  [disabled]="disabled"
  [ngClass]="{'icon-only': iconOnly, 'selected': selected}"
  type="{{type}}"
  [attr.form]="form ? form : undefined">
  @if (icon) {
    <i class="{{icon}}"></i>
  }
  <span #content>
    <ng-content></ng-content>
  </span>
</button>
